

WL.registerComponent('game', {
    startPos: { type: WL.Type.Object },
    titlePos: { type: WL.Type.Object },
    player: { type: WL.Type.Object },
    scoreTextObject: { type: WL.Type.Object }
}, {
    init: function () {
        this.initialized = false;
        window.SW.gameState.state = State.init;        
        this.scoreText = this.scoreTextObject.getComponent('text');
    },
    start: function () {
        document.getElementById("lights").style.display = "none";
    
        window.SW.gameState.stateSubject.subscribe((state) => {
            if (state == State.init) return;

            if (state == State.title) {
                this.onTitleState();
            }

            if (state == State.gameplay) {
                this.onGameplayState();
                window.SW.gameState.reset();
            }
            this.checkState();
        });
        this.initAudio();

        window.SW.gameState.state = State.title;

        window.addEventListener('keyup', (e) => {
            if (e.code == 'BracketLeft' || e.code == 'Space') {
                window.SW.gameState.state = State.gameplay;
            }
            if (e.code == 'BracketRight') {
            }
        });

    },
    onGameplayState() {
        let pos = [];
        this.startPos.getTranslationWorld(pos);
        let pPos = [];
        this.player.getTranslationWorld(pPos);
        this.player.setTranslationWorld([pos[0], pos[1], pos[2]]);
        
        window.SW.instructions.play('start');
    },
    onTitleState() {
        let pos = [];
        this.titlePos.getTranslationWorld(pos);
        let pPos = [];
        this.player.getTranslationWorld(pPos);
        this.player.setTranslationWorld([pos[0], pos[1], pos[2]]);
    },

    update: function (dt) {

    },

    initAudio() {
        if (this.initialized) return;

        this.initialized = true;
        this.songs = [
            new Audio('SantasWorkshop.mp3'),
            new Audio('ChristmasOverture.mp3'),
            new Audio('HiddenGifts.mp3')
        ];
        this.currentSong = new Audio();
        this.isPlaying = false;
        this.firstTime = true;

        WL.onXRSessionStart.push(this.onXRSessionStart.bind(this));
        WL.onXRSessionEnd.push(this.onXRSessionEnd.bind(this));
        window.SW.gameState.cryingKidsSubject.subscribe((v)=>{
            if(v>=5){  // game over 2 secs after 5th crying kid
                this.scoreText.text = `You've made ${window.SW.gameState.score} children happy!`
                setTimeout(()=>{        
                    window.SW.gameState.state = State.title;
                },2000);
            }
        });
    },
    onXRSessionStart() {
        {
            if (this.firstTime) {
                this.checkState();                
                this.firstTime = false;
                window.SW.soundEffects.initAudio();            
                return;
            }                
        };
    },
    onXRSessionEnd() {
        this.currentSong.pause();
        this.isPlaying = false;
    },

    checkState() {
        if (!this.initialized) return;
        switch (SW.gameState.state) {
            case State.title:
                this.playMusic(Songs.title);
                break;
            case State.gameplay:
                this.playMusic(Songs.gameplay);
                break;
            case State.complete:
                this.playMusic(Songs.complete);
                break;
            default:
                this.currentSong.pause();
                this.isPlaying = false;
                break;
        }
    },

    playMusic(audioIndex) {
        if (!this.initialized) return;
        this.currentSong.src = this.songs[audioIndex].src;
        this.currentSong.loop = true;
        this.currentSong.volume = 0.25;
        this.currentSong.play();
        this.isPlaying = true;
    }
});

